import React, {Component} from 'react';
import contact from '../gifs/contact.gif';
import {Card,  CardText, CardBody,CardTitle,  Button} from 'reactstrap';

class Projects extends Component {


    render() {
        return(
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-5" style={{justifyContent: "center", alignItems: "center", padding:"25px"}}>
                        <img src={contact} alt="Oops!" height="100%" width="100%" justifyContent="center" backgroundSize="cover"/>
                    </div>
                    <div className="col-12 col-md-6 my-auto" style={{justifyContent: "space-around",padding:"25px", alignItems: "center"}}>
                        <h2 style={{fontFamily:'Menlo'}}>Projects</h2>
                        <hr style={{height:"1.2px", width:"14%",textAlign:"left",marginLeft:"0",backgroundColor:"gray"}}/>
                        <p style={{fontFamily:"Montserrat", fontSize:"22px"}}>&emsp;&emsp;Find a project and contribute because it takes reading to learn a skill and practice to master it.</p>
                        <cite style={{fontFamily:"Montserrat", color:"gray"}}>Learn &amp; Practice.</cite>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12" style={{justifyContent: "space-around",padding:"28px", alignItems: "center"}}>
                            <h2 style={{fontFamily:'Menlo'}}>Where should I start?</h2>
                            <hr style={{height:"1.2px", width:"16%",textAlign:"left",marginLeft:"0",backgroundColor:"gray"}}/>
                            <p style={{fontFamily:"Montserrat", fontSize:"20px", color:"#2A2A2A"}}>&emsp;&emsp;Before going any further make sure you know how to contribute.If not then, start by reading about it from the collaborate tab.
                            <br/> If you know how to collaborate then follow these steps:
                            <ol>
                                <li>Pick a project from below.</li>
                                <li>In the projects page go to the section you want to contribute to.</li>
                                <li>Follow the instructions given in that section.</li>
                                <li>When a PR(pull request) is raised it will be merged in 24 hours.</li>
                            </ol>
                                <h4 style={{fontFamily:'Menlo'}}>You've successfully contributed. Cheers!</h4>
                            </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12" style={{justifyContent: "space-around",padding:"28px", alignItems: "center"}}>
                        <h2 style={{fontFamily:'Menlo'}}>You can Contribute to</h2>
                        <hr style={{height:"1.2px", width:"16%",textAlign:"left",marginLeft:"0",backgroundColor:"gray"}}/>
                    </div>
                    <div className="mx-auto" style={{justifyContent: "center", alignItems: "center", padding:"25px"}}>
                        <Card>
                            <CardBody>
                                <CardTitle style={{color:"black",fontFamily:'Menlo',fontSize:"20px"}}>Portfolio</CardTitle>
                                <CardText>
                                    <ul className="list-unstyled">
                                        <li style={{fontFamily:"Montserrat", fontSize:"18px"}}>Started on: <span style={{color:"gray",fontFamily:'Menlo'}}>17 Sept. 2020</span></li>
                                        <li style={{fontFamily:"Montserrat", fontSize:"18px"}}>Status: <span style={{color:"Orange",fontFamily:'Menlo'}}>Ongoing.</span></li>
                                        <li style={{fontFamily:"Montserrat", fontSize:"18px"}}>Current Version: <span style={{color:"blue",fontFamily:'Menlo'}}>0.2</span></li>
                                    </ul>
                                </CardText>
                                <Button>Button</Button>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div>
        );
    }
}

export default Projects;